module.exports = __webpack_public_path__ + "processor-worker.bc530.worker.js"